<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="视频详情"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    >
      <template #right>
        <van-icon name="share" @click="shareHandler" />
      </template>
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->
    <div id="desc" v-if="vMemorialHallDetailed" style="display:none" 
      v-html="vMemorialHallDetailed.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].LifeIntroduction" ></div>
    <div v-if="model">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
      <div class="video-title">{{model.Title}}</div>
      <p class="video-date">{{model.AddDateTime}}</p>

      <!-- <CommentBox /> -->

      <div class="appbarSpace"></div>
      <!-- <div class="van-hairline--top appbarBottom">
      	<router-link to="" class="item">
      		<van-icon name="edit" />
      		<span class="text">编辑</span>
      	</router-link>
      	<router-link to="" class="item">
      		<van-icon name="envelop-o" />
      		<span class="text">发送</span>
      	</router-link>
      	<router-link to="" class="item">
      		<van-icon name="share" />
      		<span class="text">分享</span>
      	</router-link>
      	<router-link to="" class="item">
      		<van-icon name="delete" />
      		<span class="text">删除</span>
      	</router-link>
      </div>-->
    </div>
  </div>
</template>

<script>
import soshm from "soshm";
import { Toast } from "vant";
// import CommentBox from '@/components/CommentBox.vue'
export default {
  data() {
    return {
      // 视频播放
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "http://vjs.zencdn.net/v/oceans.mp4" //url地址
            // src: "" //url地址
          }
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      id: 0,
      model: null,
      mid : 0,
      vMemorialHallDetailed : null,
    };
  },
  //   components: {
  //   	CommentBox
  // },
  methods: {
    onClickLeft() {
      this.$back();
      //this.$router.go(-1);
    },
    /**推荐给朋友**/
    shareHandler() {
      if (this.$weixin.IsWeiXin()) {
        soshm.weixinSharetip();
      } else {
        Toast("当前暂不支持分享");
      }

      // soshm.popIn({
      //   title: "弹窗分享",
      //   sites: ["weixin", "weixintimeline", "weibo", "qzone", "tqq", "qq"]
      // });
    },
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetVideoVideoDetailed",
          Id: that.id
        })
        .then(
          res => {
            // console.log(res);
            that.model = res.VideoApiModel;
            if (res.VideoApiModel.VideoPath) {
              that.playerOptions.sources[0].src = res.VideoApiModel.VideoPath;
            }
          },
          err => {}
        );
    },
    initShare(id) {
      var that = this;
      var options = {
        type: "GetMemorialHallSearchApiById",
        id: id
      };
      that.$store.dispatch(options).then(res => {
        // console.log(res);
        that.vMemorialHallDetailed = res;
        if(res.MemorialHallSearchApiModel){
          that.$store.commit('setmid', res.MemorialHallSearchApiModel.SerialNumber);
          that.$store.commit('setmuid', res.MemorialHallSearchApiModel.MemorialHallID);
        }
        if(that.$weixin.IsWeiXin()){
          that.initweixinShare();
        }
      });
    },
    initweixinShare(){
      var that = this;
        this.$nextTick(() => {
          let desc = document.querySelector("#desc").innerText;
          if(!desc){
            desc = that.vMemorialHallDetailed.MemorialHallSearchApiModel.Title;
          }
          that.$weixin.ShareWeiXinAppMessage(
            that.vMemorialHallDetailed.MemorialHallSearchApiModel.Title,
            desc,
            that.vMemorialHallDetailed.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].HeadPhoto,
            'MemorialHall?id=' + that.mid
          );
        })
        
    }
  },
  created() {
    var that = this;
    that.id = this.$route.query.id;
    that.mid = this.$route.query.mid;
    this.initShare(that.mid);
    this.init();
  }
};
</script>

<style scoped>
.video-player {
  margin: 15px;
}
.video-title {
  text-align: center;
  font-size: 16px;
  margin-top: 15px;
  padding: 0 15px;
}
.video-date {
  font-size: 12px;
  color: #bbb;
  text-align: center;
  padding: 0 15px;
}
</style>
